// El tipo de retorno conserva la union literal de claves a proposito. Ensancharlo a
// `string` rompe las APIs de antd que exigen un nombre de campo tipado
// (Form.useWatch, form.getFieldValue), que se endurecieron en antd 5.29+/6.
export const nameof = <T>(name: Extract<keyof T, string>): Extract<keyof T, string> => name;

export const getProperties = (o: any): { key: string; value: any }[] => {
  const result = [];
  for (const key in o) {
    if (Object.prototype.hasOwnProperty.call(o, key)) {
      result.push({ key, value: o[key] });
    }
  }

  return result;
};

export const getKeyValuePairs = <V>(o: any): { key: string; value: V }[] => {
  const result = [];
  for (const key in o) {
    if (Object.prototype.hasOwnProperty.call(o, key)) {
      result.push({ key, value: o[key] as unknown as V });
    }
  }

  return result;
};
